module.exports = __webpack_public_path__ + "static/media/body_trace_weight_scale.76825dc7.png";